import React from "react";
import { Container } from "reactstrap";
import "./Comp-Header.css";
import { Link } from "react-router-dom";


const CompHeader = () => {

    return (
        <section>
            <Container className="comp-header-container">
                <div className="comp-header-title">
                    <b>Электростатикалық өріс потенциалы</b>
                    <Link to="/ex-prep">
                        <button className="comp-header-button" style={
                            {
                                float: 'right',
                                width: '250px',
                                height: '40px',
                                fontSize: '20px',
                                borderRadius: '50px',
                                color: '#000000',
                                backgroundColor: '#00daf4'
                            }
                        }>
                            қосымша түсіндірме 
                        </button>
                    </Link>
                    <br />
                    Өрісті есептеуге арналған <a href="https://kk.wikipedia.org/wiki/%D0%93%D0%B0%D1%83%D1%81%D1%81_%D1%82%D0%B5%D0%BE%D1%80%D0%B5%D0%BC%D0%B0%D1%81%D1%8B" title="Гаусс теоремасы, электр динамикасында — электр статикасының S тұйық бет арқылы өтетін электр индукциясының (D) сол бетті қамтитын көлем (V) ішіндегі зарядқа (Q) пропорционалдығын тұжырымдайтын негізгі теоремасы. ">Гаусс</a> теоремаларын қолдану
                </div>
                <div className="comp-header-content-container">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6yk_c9RHKwBmrRtmLeEATBx9fS_4nCJox5F_glLKThC4nvFuZg-YrxX6anRfo4gtojX0&usqp=CAU" alt="" />
                    <img className="src-image" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTK9IdV9vP_hgGuX8czJzVjW7I-6QddT44DXO-A0gL08JtntdnwdG_TXTMYzp_msWbMCjc&usqp=CAU" alt="" />
                    <img className="src-image" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiCrs0DZEvMhPAQxioNSoGkiEdM46g4R1IwhC8CIMp80JYSoweFkfEPbQUipV3jkWLUX8&usqp=CAU" alt="" />
                </div>
                <div className="component-content">
                    Зарядтарды электростатикалық өріске ауыстырғанда, оларға түсірілетін күштер жұмыс атқарады.
                    Электростатикалық күштердің бір ерекшелігі олардың заряд орын ауыстырғандағы жұмысы, зарядтың
                    қандай жолмен орын ауыстырғандығына байланыссыз, тек зарядтың шамасы мен оның бастапқы және
                    соңғы орнына ғана байланысты болады.
                </div>
            </Container>
        </section>
    );
};

export default CompHeader;